import { useState } from "react";
import PageHeader from "@/components/PageHeader";

import ContractorAlert from "./ContractorAlert";
import { useContractorContext } from "../context";
import { useContractorBreadcrumbs } from "../hooks";
import { ContractorMenu } from "./ContractorMenu";
import ContractorDetails from "./ContractorDetails";
import ContractorAssignments from "./ContractorAssignments";
import { ContractorAgreementCreateDialog } from "./ContractorAgreementDialog";
import { ContractorLoader } from "./ContractorLoader";

const ContractorContent = () => {
  const { data, errorState, loadingState } = useContractorContext();
  const [agreementDialogOpen, setAgreementDialogOpen] = useState(false);
  const { breadcrumbItems } = useContractorBreadcrumbs();

  if (loadingState.isLoading) {
    return <ContractorLoader reason={loadingState.reason} />;
  }

  if (errorState.error) {
    return (
      <ContractorAlert
        title="errors.genericTitle"
        message={errorState.error.message}
      />
    );
  }

  if (!data) {
    return (
      <ContractorAlert title="table.noData" message="contractors.noData" />
    );
  }

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <ContractorMenu setAgreementDialogOpen={setAgreementDialogOpen} />
      <div className="space-y-6">
        <ContractorDetails />
        <ContractorAssignments />
      </div>
      <ContractorAgreementCreateDialog
        open={agreementDialogOpen}
        onOpenChange={setAgreementDialogOpen}
      />
    </>
  );
};

export default ContractorContent;
